// Steps/Step4Details.tsx
import { Stack, TextInput } from '@mantine/core';
import type { WizardState } from '../types';
import { HtmlEditor } from '@/components';

export default function Step4Details({ caseName, setCaseName, description, setDescription }: WizardState) {
  return (
    <Stack gap="md">
      <TextInput
        label="Case Name"
        placeholder="Enter a case name"
        value={caseName}
        onChange={(e) => setCaseName(e.currentTarget.value)}
        required
      />
      <HtmlEditor
        label="Description"
        placeholder="Case description"
        value={description}
        onHtmlChange={(html) => setDescription(html)}
        minHeight={150}
      />
    </Stack>
  );
}